import DropDown, { DropdownOption } from 'components/Input/Dropdown'

interface DomainSelectorProps {
  handleSelect: (option: any) => void
  options: DropdownOption[]
  value: DropdownOption
  id: string
}
function DomainSelector({
  handleSelect,
  options,
  value,
  id,
  ...props
}: DomainSelectorProps) {
  return (
    <DropDown
      name={id}
      value={value}
      onChange={handleSelect}
      isClearable
      placeholder=""
      options={options}
      {...props}
    />
  )
}

export default DomainSelector
